import { KeenIcon } from '@/components';
import { act, forwardRef } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';  

const CategoryModal = forwardRef(({ 
    open, 
    onCloseModal, 
    handleMode, 
    data, 
    onSubmit,
    createFieldLoading,
    updateFieldLoading,
 }, formikRef) => {
    if (!open) return null;
    const isViewMode = handleMode === 'edit';

    const validationSchema = Yup.object().shape({
        category_name: Yup.string().required('Category Name is required'),
        // category_code: Yup.string().required('Category Code is required'),
        // status: Yup.boolean()
    });
    
    const initialValues = {
        category_name: data?.category_name || '',
        category_code: data?.category_code || '',
        active: data?.active ?? 1,
        description: data?.description || '',
    };
    console.log('initialValues', initialValues  )

  return (
    <div className="modal-wrapper modal-animate-fade">
      
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        innerRef={formikRef}
        onSubmit={(values, formikRef) => {
            const payload = {
                ...values,
                active: Number(values.active)
            }
            // console.log('payload', payload)
            // return
            onSubmit(payload, formikRef)
        }}
      >

        {({ errors, values, handleChange, handleSubmit, setFieldValue }) => (  
            console.error('Errors', errors),
            <Form onSubmit={handleSubmit} className="modal-animate-scale scrollable-y-auto bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark] border border-gray-300 dark:border-t-light dark:border-light p-6 rounded-lg shadow-lg w-4/5 max-w-xl relative">
                <h3 className="card-title capitalize mb-5">
                    {isViewMode ? 'Edit' : 'Create'} Expense Category
                    </h3>
                <button
                    type="button"
                    onClick={onCloseModal}
                    className="modal-close-btn"
                    >
                    <KeenIcon icon="cross" />
                </button>
                
                <div className='w-full'>
                    <label className="form-label mb-1">Category Name <span className='pl-px text-red-600'>*</span></label>
                    <Field name="category_name" className="input" />
                    <ErrorMessage name="category_name" component="div" className="text-red-500 text-xs mt-1" />
                </div>

                <div className='w-full my-3'>
                    <label className="form-label mb-1">Category Code </label>
                    <Field name="category_code" className="input" />
                    <ErrorMessage name="category_code" component="div" className="text-red-500 text-xs mt-1" />
                </div>

                <div className='w-full'>
                    <label className="form-label mb-1">Status</label>
                    <Field as="select" className="input" name="active">
                        <option value={1}>Active</option>
                        <option value={0}>Inactive</option>
                    </Field>
                </div>

                <div className='w-full my-3'>
                    <label className="form-label mb-1">Description</label>
                    <Field name="description" as="textarea" rows="4" cols="50" className="min-h-[120px] input py-3 leading-[1.4em]" />
                    <ErrorMessage name="description" component="div" className="text-red-500 text-xs mt-1" />
                </div>

                <button type="submit" disabled={createFieldLoading || updateFieldLoading} className="btn btn-primary justify-center w-full mt-2">
                {isViewMode ? 
                    updateFieldLoading ? 'Please Wait...' : 'Update Expense Category' 
                : createFieldLoading ? 'Please wait...' : 'Create Expense Category'}
                </button>
            </Form>
        )}
      </Formik>
    </div>
  );
});

export { CategoryModal };
